// extracted by mini-css-extract-plugin
export var infoItem = "_ud-2";
export var title = "_ud-0";
export var value = "_ud-1";